const TASK_TYPES = [
  'onboarding',
  'offboarding',
  'training',
  'document',
  'reviewee',
  'survey',
  'offer',
  'expense'
];

export default TASK_TYPES;
